(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('Port', Port);

    Port.$inject = ['$resource'];

    function Port ($resource) {
        var resourceUrl =  'api/ports/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByCorporation': {url: 'api/ports/by-corporation/:id', method: 'GET', isArray: true}
        });
    }
})();
